import React, { useEffect, useState } from "react";
import { FaPlus, FaSearch } from "react-icons/fa";
import { FiCalendar } from "react-icons/fi";
import ClinicalNotesTable from "./ClinicalNotesTable";
import NoteDetailsModal from "./NoteDetailsModal";
import AddNoteModal from "./AddNoteModal";
import ClinicalNotesService from "../../../../Services/ClinicalNotesService";
import dayjs from "dayjs";

const MOCK_NOTES = [
  {
    id: 1,
    datetime: "02 Jul 2026, 10:30 AM",
    recordedBy: "Dr. Hari Prakash",
    type: "Progress Note",
    content: "Fever reduced, patient responding well to treatment.",
    fullContent:
      "Fever reduced, patient responding well to treatment.\nVitals stable.\nAdvised to continue IV fluids and antibiotics.\nMonitor vitals 6 hourly.\nPlan: Review tomorrow.",
    attachments: 2,
  },
  {
    id: 2,
    datetime: "01 Jul 2026, 06:15 PM",
    recordedBy: "Dr. Hari Prakash",
    type: "Initial Note",
    content: "High grade fever, started on IV antibiotics.",
    attachments: 1,
  },
  {
    id: 3,
    datetime: "30 Jun 2026, 11:20 AM",
    recordedBy: "Nurse Kavitha R",
    type: "Nursing Note",
    content: "Temperature improving, continue treatment.",
    attachments: 1,
  },
  {
    id: 4,
    datetime: "28 Jun 2026, 09:45 AM",
    recordedBy: "Dr. Hari Prakash",
    type: "Initial Note",
    content: "Patient admitted with fever and weakness.",
    attachments: 1,
  },
  {
    id: 5,
    datetime: "27 Jun 2026, 04:30 PM",
    recordedBy: "Dr. Hari Prakash",
    type: "Progress Note",
    content: "Condition stable, monitoring vitals.",
    attachments: 1,
  },
  {
    id: 6,
    datetime: "26 Jun 2026, 12:00 PM",
    recordedBy: "Nurse Kavitha R",
    type: "Nursing Note",
    content: "Patient condition improved, discharged plan initiated.",
    attachments: 1,
  },
  {
    id: 7,
    datetime: "25 Jun 2026, 10:10 AM",
    recordedBy: "Dr. Hari Prakash",
    type: "Progress Note",
    content: "IV fluids continued, antibiotics ongoing.",
    attachments: 1,
  },
];

function ClinicalNotes({ patientDetails, patientId, admissionId }) {
  const [activeNote, setActiveNote] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [list, setList] = useState([]);

  const handleViewNote = (note) => {
    setActiveNote(note);
  };

  const handleEditNote = (note) => {
    console.log("Edit note", note);
  };

  const getList = async () => {
    try {
      let res = await ClinicalNotesService.getPatientClinicalNotes({
        pageNo: 1,
        pageSize: 10,
        patientId: patientId || undefined,       
        nurseActionRequired: "N",
        encounterId: admissionId,
        status: "CLOSED",
      });
      const data = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.data?.content)
          ? res.data.content
          : [];
      setList(data);
    } catch (e) {
      console.error("Error fetching clinical notes:", e);
    }
  };
  useEffect(() => {
    getList();
  }, [patientId]);
  return (
    <div className="flex flex-col gap-6 p-2">
      {/* HEADER */}
      <div className="flex items-center justify-between">
        <h2 className="text-[20px] font-bold text-[#111827]">Clinical Notes</h2>

        <div className="flex items-center gap-4">
          <button
            onClick={() => setIsAddModalOpen(true)}
            className="h-10 px-5 rounded-lg bg-[#008f9f] text-white text-[13px] font-semibold flex items-center gap-2 hover:bg-[#007a8a] transition-colors"
          >
            <FaPlus className="text-[12px]" />
            Add Clinical Note
          </button>
        </div>
      </div>

      {/* TABLE */}
      <ClinicalNotesTable
        notes={list}
        onView={handleViewNote}
        onEdit={handleEditNote}
      />

      {/* MODALS */}
      <NoteDetailsModal note={activeNote} onClose={() => setActiveNote(null)} />

      {isAddModalOpen && (
        <AddNoteModal
          patientDetails={patientDetails}
          patientId={patientId}
          admissionId={admissionId}
          onSuccess={getList}
          onClose={() => setIsAddModalOpen(false)}
        />
      )}
    </div>
  );
}

export default ClinicalNotes;
